import React, {useMemo, useRef, useState} from "react";
import { Controller } from 'react-hook-form';
import JoditEditor from "jodit-react";

const config = {
  readonly: false,
  removeButtons: ["about", "file", "video", "image", "print", "fullsize", "classSpan"],
  theme: 'default',
  // placeholder: 'Start typings...'
}

export default function ({
                           name,
                           control,
                           parentClasses,
                           errorMessage = "",
                           placeholder,
                           label,
                         }) {

  const editor = useRef(null);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <div className={` ${parentClasses}`}>
            <label className='form-label fs-6 fw-bolder text-dark'>
              {label}
            </label>
          <JoditEditor
            ref={editor}
            value={value}
            config={config}
            tabIndex={1} // tabIndex of textarea
            onChange={(val) => onChange(val)}
          />
            {errorMessage && (
              <div className="fv-plugins-message-container invalid-feedback">
                <div>{errorMessage}</div>
              </div>
            )}
          </div>
        )
        }
      />
    </>
  );
}